import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';

import { HtmlAnchorTarget } from '@web/utils';

@Component({
  selector: 'app-external-link',
  imports: [],
  templateUrl: './external-link.component.html',
  styleUrl: './external-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalLinkComponent {
  public readonly contents = input<boolean>(false);
  public readonly underline = input<boolean>(true);
  public readonly link = input.required<string>();
  public readonly target = input<HtmlAnchorTarget>(HtmlAnchorTarget.Blank);

  @HostBinding('class.contents')
  public contentsClass(): boolean {
    return this.contents();
  }
}
